import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useCart } from "../context/CartContext";

export const BagReminder = () => {
  const { count, isOpen, setIsOpen } = useCart();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (count > 0 && !sessionStorage.getItem("raystance_reminder_shown")) {
      const t = setTimeout(() => {
        setVisible(true);
        sessionStorage.setItem("raystance_reminder_shown", "1");
      }, 3000);
      return () => clearTimeout(t);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isOpen) setVisible(false);
  }, [isOpen]);

  return (
    <AnimatePresence>
      {visible && count > 0 && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-6 left-6 z-50 max-w-xs bg-coal border border-gold/30 px-6 py-5"
          data-testid="bag-reminder"
        >
          <button
            onClick={() => setVisible(false)}
            className="absolute top-3 right-3 text-ash hover:text-gold transition-colors duration-300"
            data-testid="bag-reminder-dismiss"
            aria-label="Dismiss reminder"
          >
            <X className="h-3.5 w-3.5" />
          </button>
          <p className="font-serif italic text-lg text-white leading-snug">
            You left {count === 1 ? "a frame" : `${count} frames`} in your bag.
          </p>
          <button
            onClick={() => {
              setVisible(false);
              setIsOpen(true);
            }}
            className="mt-3 text-xs uppercase tracking-[0.25em] text-gold hover:text-champagne transition-colors duration-300"
            data-testid="bag-reminder-view"
          >
            View Bag →
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
